import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen p-8 text-justify">
      <div className="max-w-4xl mx-auto bg-white  p-8 mt-20">
        <h1 className="text-3xl font-bold text-blue-700 mb-6 text-center">Privacy Policy</h1>
        
        <div className="space-y-8 text-gray-700">
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-amber-500">Privacy Commitment</h2>
            <p className="mb-4">
              In the course of using this website, mobile applications or its custom extensions or availing the products and services vide the online application forms and questionnaires, Janatha Automobiles Pvt Ltd and its Business Partners/ Affiliates may become privy to the personal information of its customers, including information that is of a confidential nature. We may collect personal identification information from website users, customers in a variety of ways, including, but not limited to, when website users or customers visit our site and in connection with other activities, services, features or resources we make available on our Site. Website users or customers may be asked for, as appropriate, name, email address, mailing address, phone number. We will collect personal identification information from website users or customers only if they voluntarily submit such information to us. Website users or customers can always refuse to supply personal identification information, except that it may prevent them from engaging in certain Site related activities.
            </p>
            <p className="mb-4">
              Janatha Automobiles Pvt Ltd is strongly committed to protecting the privacy of its customers and has taken all necessary and reasonable measures to protect the confidentiality of the customer information and its transmission through the world wide web and it shall not be held liable for disclosure of the confidential information when in accordance with this privacy Commitment or in terms of the agreements, if any, with the Customers.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-amber-500">Information Security</h2>
            <p className="mb-4">
              Janatha Automobiles Pvt Ltd endeavours to safeguard and ensure the security of the information provided by the Customer. Janatha Automobiles Pvt Ltd uses 128-bit encryption, for the transmission of the information, which is currently the permitted level of encryption in India. When the information provided by the Customers is not transmitted through this encryption, the Customers' system (if configured accordingly) will display an appropriate message ensuring the best level of secrecy for the Customer's information.
            </p>
            <p className="mb-4">
              The Customer would be required to cooperate with Janatha Automobiles Pvt Ltd in order to ensure the security of the information, and it is recommended that the Customers necessarily choose their passwords carefully such that no unauthorised access is made by a third party. The Customers should undertake not to disclose their password to anyone or keep any written or other record of the password such that a third party could access it.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-amber-500">Information Usage</h2>
            <p className="mb-4">We use the information we collect from you for the following purposes:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li>To provide our Services</li>
              <li>To send you promotional, transactional and/or marketing communications</li>
              <li>To respond to your requests and inquiries</li>
              <li>To improve user experiences by making our website easier to use and navigate</li>
              <li>For other legitimate business purposes</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-amber-500">Third-Party Sharing</h2>
            <p className="mb-4">We may share or disclose your information to:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li>Third-party service providers, agents or independent contractors who help us maintain our Services</li>
              <li>Manufacturers or unaffiliated third parties whose products/services we believe might interest you</li>
              <li>Law enforcement, government agencies, and related third parties to comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-amber-500">User Consent</h2>
            <p className="mb-4">By using the website:</p>
            <ol className="list-decimal pl-6 space-y-2 mb-4">
              <li>You unconditionally consent to data collection and storage</li>
              <li>You authorize information sharing per this policy</li>
              <li>You agree to inform us about any consent withdrawal</li>
            </ol>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-amber-500">Policy Updates</h2>
            <p className="mb-4">
              Janatha Automobiles Pvt Ltd has the discretion to update this privacy policy at any time. When we do, we will revise the updated date at the bottom of this page. A revised Privacy Policy will only apply to data collected subsequent to its effective date. Any revisions will be posted at least 15 days prior to its effective date.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-amber-500">Cookie Policy</h2>
            <p className="mb-4">
              Janatha Automobiles Pvt Ltd website uses Google Analytics, a web analytics service provided by Google, Inc. ("Google"). Google Analytics uses cookies that are text files containing small amounts of information (this does not include personal sensitive information), which are downloaded to your device when you visit a website. By using our website, users agree that these types of cookies can be placed on their device. Users are free to disable/delete these cookies through browser settings.
            </p>
          </section>

          <section>
            <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-200">
              <h3 className="text-lg font-semibold text-yellow-800 mb-2">Disclaimer</h3>
              <p className="text-yellow-700">
                This website "www.japl.co.in" should be accessed only if you agree to our terms. Your continued use constitutes acceptance of any policy changes.
              </p>
            </div>
          </section>

          {/* <div className="text-right text-sm italic text-gray-500">
            Effective Date: [DD/MM/YYYY]
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;